export default {
  saved: "Daten wurden erfolgreich gespeichert",
  updated: "Daten wurden erfolgreich aktualisiert",
  deleted: "Daten wurden erfolgreich gelöscht",
  sent: "Anfrage wurde erfolgreich gesendet",
  error: "Systemfehler - Bitte wenden Sie sich an den Administrator",
};
